import { OrderStatus } from 'types/api/order'
import sendData from '../../../utils/sendData'

export const complete = (state: OrderStatus, orderId: string) => {
  sendData('order_history.order.deletion.complete', {
    state,
    orderId,
  })
}
